<template>
  <div class="sidenav-navigation">
    <!--    <code>{{  all }}</code>-->
    <div class="left-menus">
      <div class="logo">
        <!-- <router-link :to="{ path: '/' }"><img src="@/assets/images/ghasforing-logo.png" width="90px" />
        </router-link> -->
      </div>
      <ul class="parent-nav">
        <li class="requestlink">
          <a class="visible-xs" href="/" v-if="language == 'EN'"><img src="@/assets/images/icons/home-ash.png" alt="" class="img-responsive" /> Back to Home
          </a>
          <a class="visible-xs" href="/" v-else><img src="@/assets/images/icons/home-ash.png" alt="" class="img-responsive" /> হোম পেজ
          </a>
          <router-link :to="{ path: '/search/product-request' }">
            <img
              style="float: left;margin-right: 4px;width:17px;margin-top:8px;"
              src="@/assets/images/icons/new-product.png"
              class="img-responsive"
            />
            {{ language == 'EN' ? 'Product Request' : 'পণ্য অনুরোধ' }}</router-link>
        </li>
        <li class="requestlink mt10" v-for="link in quickLinks" :key="link.id">
          <router-link :to="{ path: link.path }">
            <category-icon :icon="link.subCategory.cat_icon" />
            {{ language == 'EN' ? link.subCategory.sub_cat_name : link.subCategory.sub_cat_name_bn }}
          </router-link>
        </li>

        <li v-for="main in all">
          <router-link :to="{
  name: 'CategoryProducts',
  params: {
    slug: main.slug,
  }
          }" class="parent">
            <div @click="mainCatToggle(main.id)" :class="'main_' + main.id">
              <span class="">
                <category-icon :icon="main.cat_icon" margin-right="4px" /></span>

              <span v-if="language == 'EN'">{{ main.cat_name }}</span>
              <span class="parent" v-else>{{ main.cat_name_bn }}</span>
              <i class="main fa fa-angle-right pull-right"></i>
            </div>
          </router-link>

          <ul class="dnone" :id="main.id">
            <!--            :to="{ path: '/'+sub_category.sub_cat_name ,params: { title: sub_category.sub_cat_name}}"-->
            <li v-for="sub_category in main.sub_category" 
                        v-if="![50, 47, 48].includes(sub_category.id)"
             >
              <router-link :to="{
          name: 'CategoryProducts',
          params: {
            slug: sub_category.slug,
            title: sub_category.sub_cat_name
          }
        }" v-bind:data-catid="'sc=' + sub_category.id" v-on:click="setActive(sub_category.sub_category_slug)"
                :class="{ active: isActive(sub_category.sub_category_slug) }">
                <div @click="subCatToggle(sub_category.id)">
                  <span>
                    <category-icon :icon="sub_category.cat_icon" />
                    {{ language == 'EN' ? sub_category.sub_cat_name : sub_category.sub_cat_name_bn }}</span>
                </div>
              </router-link>
              <ul class="dnone sub" :id="'sub_' + sub_category.id">
                <li v-for="child_sub in sub_category.child_sub_cats">
                  <router-link :to="{
          name: 'CategoryProducts',
          params: {
            slug: child_sub.slug,
            title: child_sub.child_cat_name
          }
        }" v-bind:data-catid="'cc=' + child_sub.id" v-on:click="setActive(child_sub.child_category_slug)"
                    :class="{ active: isActive(child_sub.child_category_slug) }">
                    <span>
                      <category-icon :icon="child_sub.cat_icon" margin-top="8px" />
                      {{ language == 'EN' ? child_sub.child_cat_name : child_sub.child_cat_name_bn }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <li class="bottom-height"></li>
      </ul>
    </div>
    <div id="sidenav-overlay" @click="closeSidenav">&nbsp;</div>
  </div>
</template>
<script>
const $ = require("jquery");
window.$ = $;
$(function() {});

import axios from "axios";
import CategoryIcon from "./CategoryIcon.vue";

const QUICK_LINK_CONFIG = [
  { id: 47, path: "/popular" },
  { id: 48, path: "/flash-sales" },
  { id: 50, path: "/wishlist" }
];

export default {
  name: "app",
  components: {
    CategoryIcon
  },
  data() {
    return {
      activeItem: "/",
      logged_in_user_name: "",
      categories: [],
      carts: [],
      products: [],
      crossIcon: false,
      searchProduct: "",
      modalProductData: "",
      changeModalGallery_image: "",
      quantity: 1,
      menuStatus: false,
      all: [],
      language: ""
    };
  },
  computed: {
    quickLinks() {
      return QUICK_LINK_CONFIG.map(link => {
        let subCategory = null;
        for (const category of this.all) {
          subCategory = (category.sub_category || []).find(
            sc => Number(sc.id) === link.id
          );
          if (subCategory) break;
        }
        return { ...link, subCategory };
      }).filter(link => link.subCategory);
    }
  },
  created: function() {
    this.allCategory();
    this.language = this.globalLanguage;
    //localStorage.clear();
  },
  mounted() {
    if (localStorage.getItem("carts")) {
      this.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      this.carts = [];
    }
    if (localStorage.getItem("logged_in_user_name")) {
      let vm = this;
      vm.logged_in_user_name = localStorage.getItem("logged_in_user_name");
    }
    //page  load  carts  items  check and  show  counting
  },
  methods: {
    mainCatToggle: function (catid) {
      $(".dnone").hide();
      $('.main').removeClass('fa-angle-down');
      $('.main').addClass('fa-angle-right');

       $("#" + catid).toggle();
      $('.main_' + catid +' .main').removeClass('fa-angle-right');
      $('.main_'+catid +' .main').addClass('fa-angle-down');

     },
    subCatToggle: function (catid) {
      $(".dnone.sub").hide();
      $("#sub_" + catid).toggle();
     },
    toogleNav: function() {
      $(".small-device #sidebar-area").toggleClass("show");
      $("#content-area").toggleClass("fullwidth");
      $("#sidebar-area").toggleClass("hidden-sidebar");
      if (this.menuStatus == true) {
        this.menuStatus = false;
      } else if (this.menuStatus == false) {
        this.menuStatus = true;
      }
    },
    closeSidenav: function() {
      this.$emit("close-menu");
    },
    hideNav: function() {
      $("#sidenav-navigation").removeClass("show");
      this.menuStatus = true;
    },
    allCategory: function() {
      let vm = this;
      axios
        .get(this.globalUrl + "all-category-list")
        .then(function(response) {
          //console.log(response.data);
          vm.all = response.data;
        })
        .catch(response => {
          //console.log(response);
          vm.$toasted.show("Something wrong  Try again.", {
            type: "error",
            icon: "fa-exclamation-triangle"
          });
        });
    },
    calculateCartTotal() {
      let vm = this;
      for (
        var i = 0, sum = 0;
        i < vm.carts.length;
        sum += vm.carts[i++].subtotal
      );
      vm.sum_cart_total = sum;
    },
    //active  seleced  page  menu
    //menuItem means catch page menu url and keep activeitem variable
    isActive: function(menuItem) {
      return this.activeItem === menuItem;
    },
    //menuItem means catch page menu url and keep activeitem variable
    setActive: function(menuItem) {
      this.activeItem = menuItem; // no need for Vue.set()
    },
    logout: function() {
      //console.log("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("logged_in_user_id");
      localStorage.removeItem("logged_in_user_name");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("is_seller");
      //this.$router.push('/login');
      this.$router.go();
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
      }
    },
    cartIncrement(product_id) {
      //alert(product_id);
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let newQuantity = oldQuantity + 1;
      let price = this.carts[objIndex].price;
      this.carts[objIndex].cart_quantity = newQuantity;
      this.carts[objIndex].subtotal = price * newQuantity;
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.carts = JSON.parse(localStorage.getItem("carts"));
      this.calculateCartTotal();
    },
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity === 1) {
      } else {
        this.quantity--;
      }
    },
    createCartsModal: function() {
      let vm = this;
      let this_product_quantity = vm.quantity;
      let singleProduct = vm.modalProductData;
      var result = JSON.parse(localStorage.getItem("carts"));
      if (result == null) result = [];
      result.push({
        product_id: singleProduct.id,
        product_name: singleProduct.name,
        product_image: singleProduct.featured_image,
        price: singleProduct.total_price,
        image: singleProduct.featured_image,
        cart_quantity: this_product_quantity,
        subtotal: singleProduct.total_price * this_product_quantity
      });
      // save the new result array
      localStorage.setItem("carts", JSON.stringify(result));
      vm.carts = JSON.parse(localStorage.getItem("carts"));
      this.calculateCartTotal();
      this.$router.go();
    }
    // clearSearch: function() {
    //   this.searchProduct= '';
    //   this.crossIcon =false;
    //   this.$router.push('/search');
    // },
  }
  // watch: {
  // searchProduct: function (val) {
  //
  //   if(val.length > 0){
  //      this.crossIcon =true;
  //    // this.$router.push({ name: 'search', params: { param } }); // -> /user/123
  //     //this.$router.push('/search/');
  //     this.$router.push({ path: `/search/${val}` }) // -> /user/123
  //   }
  // }
  // }
};
</script>

 